module.exports = __webpack_public_path__ + "img/networking.e846e314.png";